import Icons from "assets";

import { Stack } from "ui/stack";
import Link from "components/partials/link/link";
import { IconButton } from "ui/icon-button";
import { Tooltip } from "ui/tooltip";

import type { LandingPageAttributes } from "hooks/api/use-touchpoint-versions";

export const StringToCopyableLink = (link?: string) => {
  if (link) {
    return (
      <Stack direction="row" spacing="0.5rem" sx={{ alignItems: "center" }}>
        <Link onClick={() => window.open(link, "_blank")} sx={{ textDecoration: "underline" }}>
          {link}
        </Link>
        <Tooltip label="Copy Link">
          <IconButton
            aria-label="Copy Link"
            size="small"
            variant="text"
            sx={{ my: -0.5 }}
            onClick={() => {
              navigator.clipboard.writeText(link);
            }}>
            <Icons.ContentCopy />
          </IconButton>
        </Tooltip>
      </Stack>
    );
  } else {
    return undefined;
  }
};

interface RedirectDestinationParams {
  selectedLP: LandingPageAttributes | undefined;
  redirectTouchpointUrl: string | null;
  redirectTouchpointNoPublishedVersion: boolean;
}

export const getRedirectDestinationValue = ({
  selectedLP,
  redirectTouchpointUrl,
  redirectTouchpointNoPublishedVersion,
}: RedirectDestinationParams) => {
  if (selectedLP?.redirectDestinationType === "NONE") {
    return "None";
  }
  if (selectedLP?.redirectDestinationType === "TOUCHPOINT") {
    if (redirectTouchpointUrl) {
      return StringToCopyableLink(redirectTouchpointUrl);
    }
    if (redirectTouchpointNoPublishedVersion) {
      return "No published version";
    }
    return "Loading...";
  }
  return StringToCopyableLink(selectedLP?.redirectDestination);
};
